import React from "react";
import  StdGrievance from "../../components/StudentTabs/StudentGrievance/StdGrievance";

const SendFeedbacks = () => {
  return (
    <div>
      <br/>
      <StdGrievance/>
    </div>
  );
};

export default SendFeedbacks;
